export default __webpack_public_path__ + "static/media/Akshaygupta_Webdeveloper.548a89a8.pdf";